import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IPODetails,IpoDocuments } from 'src/app/models/IPO';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-ipo-selected-symbol-timline-pdf',
  templateUrl: './ipo-selected-symbol-timline-pdf.component.html',
  styleUrls: ['./ipo-selected-symbol-timline-pdf.component.scss']
})
export class IpoSelectedSymbolTimlinePdfComponent implements OnInit {

  lang: string;
  isDarkTheme: boolean;
  DisabledEtrade: boolean = false; // Initialize to false
  @Input() ipoDocuments: IpoDocuments;
  @Input() id: number;
  iPODetails: IPODetails;
  ipoList: any;
  status: any;

  constructor(
    public translate: TranslateService,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.lang = this.translate.currentLang;
    this.isDarkTheme =
      localStorage.getItem("darktheme") == "dark" ? true : false;
    this.GetIpoDetails(this.id);

  }
  GetIpoDetails(id:number){
    this.apiService.GetIpoDetails(id)
    .subscribe(
      (res)=>{
        this.iPODetails = res;
        this.checkDisabledEtradeStatus();
      }
    )
  }

  checkDisabledEtradeStatus(): void {
  
    if (this.ipoDocuments && Array.isArray(this.ipoDocuments.OprEvents)) {

      const hasDisabledEtrade = this.ipoDocuments.OprEvents.filter(
        event => event.DisabledEtrade === true || event.DisabledEtrade === 'true'
      );
      if (hasDisabledEtrade.length > 0) {

              
      const eventsWithStatus = this.ipoDocuments.OprEvents.filter(
        event => event.status != 0 &&  event.status != 1 
      );
      if (eventsWithStatus.length<0) {
        
        this.DisabledEtrade = false
        
      }
      else{
        this.DisabledEtrade = true

      }
      } 
      else {


        this.DisabledEtrade = true

      }
    } 
  }
  

  getRowIndexes(length: number): number[] {
    return Array.from({ length: Math.ceil(length / 2) }, (_, i) => i * 2);
  }
}
